import React from 'react';
import './theme/index.scss';

interface BranderProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {}

const Brander = ({ children, ...divAttributes }: BranderProps) => (
  <div {...divAttributes} className="raven-brander">
    {children}
  </div>
);

Brander.displayName = 'Brander';

export default Brander;
